enum TitleTypes {
  Candidate = 'Simera Home',
  Default = 'Simera Team',
}

export default TitleTypes;
